/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plans_Lifetime_FeaturesInputs */

const en_pricing_plans_lifetime_features = /** @type {(inputs: Pricing_Plans_Lifetime_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`["All Pro features","100 GB storage","Dedicated support","Enterprise-grade security","Advanced integrations","Custom branding","Lifetime updates"]`)
};

const es_pricing_plans_lifetime_features = /** @type {(inputs: Pricing_Plans_Lifetime_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`["Todas las funciones Pro","100 GB de almacenamiento","Soporte dedicado","Seguridad empresarial","Integraciones avanzadas","Marca personalizada","Actualizaciones de por vida"]`)
};

/**
* | output |
* | --- |
* | "[\"All Pro features\",\"100 GB storage\",\"Dedicated support\",\"Enterprise-grade security\",\"Advanced integrations\",\"Custom branding\",\"Lifetime updates\"]" |
*
* @param {Pricing_Plans_Lifetime_FeaturesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_plans_lifetime_features = /** @type {((inputs?: Pricing_Plans_Lifetime_FeaturesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plans_Lifetime_FeaturesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_plans_lifetime_features(inputs)
	return es_pricing_plans_lifetime_features(inputs)
});